module.exports = __webpack_public_path__ + "media/site_templates/www.lawnmowingservices.me/images/our_services_3-4b3220f8c350ea1a0d481a4c54b1ef19.jpg";